export default __webpack_public_path__ + "static/media/left-arrow.9e43f735.svg";